import script from "./CalendarDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./CalendarDashboard.vue?vue&type=script&setup=true&lang=js"

import "./CalendarDashboard.vue?vue&type=style&index=0&id=2d11d45a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d11d45a"]])

export default __exports__